



















































































































































import Vue from 'vue';
import {ToggleComponent} from '@mobi-components/toggle';
import VueSlider from 'vue-slider-component';
import LabelCheckBox from '../../../common-components/checkbox/label-checkbox.vue';
import Slider from '@common/slider/slider.vue';
import NumbersDropdown from '@common/dropdown/drop-down-number.vue';
type Intervals = '0' | '25' | '50' | '75' | '100';
export default Vue.extend({
  name: 'ItineraryPreferencesMeals',
  components: {ToggleComponent, VueSlider, LabelCheckBox, Slider, NumbersDropdown},
  props: {},
  data() {
    return {
      isBreakfastWindow: true,
      isLunchWindowActive: true,
      isDinnerWindowActive: true,
      sitting: 'Dine out, most meals',
      dropDownGrocery: '1',
      dropDownHappy: '1',
      personalModes: [] as string[],
      breakfastWindow: [8, 12],
      lunchWindow: [12, 17],
      dinnerWindow: [17, 22],
      intervalMarks: {
        0: {
          label: 'Stay In, all meals',
          labelStyle: {
            transform: 'translateX(0)',
          },
        },
        25: 'Stay In, most meals',
        50: 'Stay in & Dine out',
        75: 'Dine out, most meals',
        100: {
          label: 'Dine out, all meals',
          labelStyle: {
            transform: 'translateX(-77px)',
          },
        },
      },
      mapper: {
        intervals: {
          'Stay In, all meals': 0,
          'Stay In, most meals': 25,
          'Stay in & Dine out': 50,
          'Dine out, most meals': 75,
          'Dine out, all meals': 100,
        },
      },
    };
  },

  methods: {
    toggleBreakfastWindow() {
      this.isBreakfastWindow = !this.isBreakfastWindow;
    },
    toggleBusTrainActive() {
      this.isLunchWindowActive = !this.isLunchWindowActive;
    },
    toggleDrivingActive() {
      this.isDinnerWindowActive = !this.isDinnerWindowActive;
    },
    handleSelect(value: string) {
      if (this.personalModes.includes(value)) {
        return (this.personalModes = this.personalModes.filter((item) => item !== value));
      }
      this.personalModes = [...this.personalModes, value];
    },
    onOptionSelectedGrocery(selectName: string) {
      this.dropDownGrocery = selectName;
    },
    onOptionSelectedHappy(selectName: string) {
      this.dropDownHappy = selectName;
    },
    handleSittingChange(value: Intervals) {
      // @ts-ignore
      this.sitting = this.intervalMarks[value].label || this.intervalMarks[value];
    },
    handleTimeChange(value: number[], prop: 'breakfastWindow' | 'lunchWindow' | 'dinnerWindow') {
      this[prop] = value;
    },

    formatTime(value: number): string {
      const AmOrPm = value >= 12 ? 'PM' : 'AM';
      const hours = Math.ceil(value % 12 || 12);
      const minutes = value % 1;
      const finalTime = `${hours}${minutes ? ':' + minutes * 60 : ''}${AmOrPm}`;
      return finalTime;
    },
  },
  computed: {
    breakfastWindowTitle(): string {
      return `${this.formatTime(this.breakfastWindow[0])} - ${this.formatTime(this.breakfastWindow[1])}`;
    },
    lunchWindowTitle(): string {
      return `${this.formatTime(this.lunchWindow[0])} - ${this.formatTime(this.lunchWindow[1])}`;
    },
    dinnerWindowTitle(): string {
      return `${this.formatTime(this.dinnerWindow[0])} - ${this.formatTime(this.dinnerWindow[1])}`;
    },
    sittingTitle(): number {
      // @ts-ignore
      return this.mapper.intervals[this.sitting];
    },
  },
});
